import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IEmailDetail } from '../interfaces/iemail-detail';

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  private BASE_URL:string = window["cfgApiBaseUrl"];
  private EMAIL_URL:string = this.BASE_URL+"emaildata"
  constructor(private http : HttpClient) { }
  
  sendEmail(email : IEmailDetail){
    return this.http.post<any>(this.EMAIL_URL, email);
  }


}
